import "../../_metronic/assets/sass/components/_loader.scss";
import { toAbsoluteUrl } from '../../_metronic/helpers'

export function Loader({ message = '' }) {
    return (
        <>
            <div className="loader">
                <div className="loader_inner">
                    <img
                        src={toAbsoluteUrl("/media/spinner.gif")}
                        alt="Loading"
                    />

                    {(() => {
                        if (message !== '') {
                            return (<p>{message}</p>)
                        }
                    })()}
                </div>
            </div>
        </>
    );
}
